module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-forward-circle-f172787f.svg";